<template>
  <qx-card-form title="部门信息">
    <qx-custom-form :noSubBtn="true" ref="baseForm" :formData="baseForm" labelWidth="120px">
      <section slot="user" slot-scope="prop">
        <ChooseWorker :isRadio="true" v-model="prop.form.user" />
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import {
  getDepartmentAllList,
  getEnumList,
} from 'api';
import ChooseWorker from 'components/choose/worker';
export default {
  components: {
    ChooseWorker,
  },
  data () {
    return {
      orgTypeOptionsBackup: [],
      baseForm: {
        orgTypeOptions: [],
        parentOrgIdOptions: [],
        form: [
          {
            label: '部门名称',
            value: 'orgName',
            type: 'input',
          },
          {
            label: '上级组织',
            value: 'parentOrgId',
            type: 'select',
            filterable: true,
          },
          {
            label: '组织类型',
            value: 'orgType',
            type: 'select',
          },
          {
            label: '负责人',
            value: 'user',
            default: {},
            slot: true,
          },
        ],
        rules: {
          orgName: [ // 部门名称
            { required: true, message: '请输入部门名称', trigger: 'blur' },
          ],
          parentOrgId: [ // 上级组织
            { required: true, message: '请选择上级组织', trigger: 'blur' },
          ],
          orgType: [ // 组织类型
            { required: true, message: '请选择组织类型', trigger: 'blur' },
          ],
          user: [ // 负责人
            { required: true, message: '请输入负责人', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {
    async getList () {
      this.baseForm.parentOrgIdOptions = await getDepartmentAllList();
      const enumsList = await getEnumList({
        codeType: 'ORGANIZE_TYPE',
      });
      this.orgTypeOptionsBackup = enumsList[0];
      this.baseForm.orgTypeOptions = enumsList[0];
    },

    setOptions () {
      this.baseForm.orgTypeOptions = this.orgTypeOptionsBackup.filter((item) => item.value !== this.$route.query.hasHeadOffice);
    },

    async sub () {
      const formData = await this.$refs.baseForm.sub();
      if (formData) {
        formData.linkMan = formData.user.linkman;
        formData.userId = formData.user.userId;
        delete formData.user;
      }
      return formData;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      res.linkMan = res.user.linkman;
      res.userId = res.user.userId;
      return res;
    },
    async init (data = {}) {
      if (data.orgType !== undefined) {
        data.orgType = String(data.orgType);
      }
      data.user = {
        linkman: data.linkMan,
        userId: data.userId,
      };
      this.$refs.baseForm.setVal(data);
      this.setOptions();
    },
  },
};
</script>

<style scoped lang="scss">
</style>
